import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  SubscribeRoadmap401,
  SubscribeRoadmap403,
  SubscribeRoadmap404,
  SubscribeRoadmap409,
  SubscribeRoadmap500,
  UnsubscribeRoadmap401,
  UnsubscribeRoadmap403,
  UnsubscribeRoadmap404,
  UnsubscribeRoadmap500
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * 현재 로그인한 사용자가 특정 로드맵의 구독을 취소합니다.
 * @summary 로드맵 구독 취소
 */
export const unsubscribeRoadmap = (
    roadmapId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `https://api.ugot.uk/api/roadmaps/${roadmapId}/subscription`,options
    );
  }



export const getUnsubscribeRoadmapMutationOptions = <TError = AxiosError<UnsubscribeRoadmap401 | UnsubscribeRoadmap403 | UnsubscribeRoadmap404 | UnsubscribeRoadmap500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmap>>, TError,{roadmapId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmap>>, TError,{roadmapId: number}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribeRoadmap>>, {roadmapId: number}> = (props) => {
          const {roadmapId} = props ?? {};

          return  unsubscribeRoadmap(roadmapId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribeRoadmap>>>
    
    export type UnsubscribeRoadmapMutationError = AxiosError<UnsubscribeRoadmap401 | UnsubscribeRoadmap403 | UnsubscribeRoadmap404 | UnsubscribeRoadmap500>

    /**
 * @summary 로드맵 구독 취소
 */
export const useUnsubscribeRoadmap = <TError = AxiosError<UnsubscribeRoadmap401 | UnsubscribeRoadmap403 | UnsubscribeRoadmap404 | UnsubscribeRoadmap500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmap>>, TError,{roadmapId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribeRoadmap>>,
        TError,
        {roadmapId: number},
        TContext
      > => {

      const mutationOptions = getUnsubscribeRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 로그인한 사용자가 특정 로드맵을 구독합니다.
 * @summary 로드맵 구독
 */
export const subscribeRoadmap = (
    roadmapId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `https://api.ugot.uk/api/roadmaps/${roadmapId}/subscription`,undefined,options
    );
  }



export const getSubscribeRoadmapMutationOptions = <TError = AxiosError<SubscribeRoadmap401 | SubscribeRoadmap403 | SubscribeRoadmap404 | SubscribeRoadmap409 | SubscribeRoadmap500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmap>>, TError,{roadmapId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmap>>, TError,{roadmapId: number}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeRoadmap>>, {roadmapId: number}> = (props) => {
          const {roadmapId} = props ?? {};

          return  subscribeRoadmap(roadmapId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubscribeRoadmapMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeRoadmap>>>
    
    export type SubscribeRoadmapMutationError = AxiosError<SubscribeRoadmap401 | SubscribeRoadmap403 | SubscribeRoadmap404 | SubscribeRoadmap409 | SubscribeRoadmap500>

    /**
 * @summary 로드맵 구독
 */
export const useSubscribeRoadmap = <TError = AxiosError<SubscribeRoadmap401 | SubscribeRoadmap403 | SubscribeRoadmap404 | SubscribeRoadmap409 | SubscribeRoadmap500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmap>>, TError,{roadmapId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof subscribeRoadmap>>,
        TError,
        {roadmapId: number},
        TContext
      > => {

      const mutationOptions = getSubscribeRoadmapMutationOptions(options);

      return useMutation(mutationOptions);
    }
    